﻿import config from "../config"
const baseUrl = config.base_url + "product/"
export default {
    list: {
        url:  baseUrl + "list",
        type: "post",
    },

}

